import { render, staticRenderFns } from "./TranActivityParameterUpdate.vue?vue&type=template&id=3652e2c0&scoped=true"
import script from "./TranActivityParameterUpdate.vue?vue&type=script&lang=js"
export * from "./TranActivityParameterUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranActivityParameterUpdate.vue?vue&type=style&index=0&id=3652e2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652e2c0",
  null
  
)

export default component.exports